import { Reveal } from "@/components/Reveal";
import { Stars } from "@/components/Stars";
import { REVIEWS } from "@/data/site";

export function Reviews() {
  return (
    <section className="bg-ink py-24 text-ivory md:py-32" data-testid="reviews">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="mb-16 text-center">
          <p className="eyebrow text-champagne">Kind Words</p>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight md:text-6xl">
            Loved by Thousands
          </h2>
        </Reveal>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r, i) => (
            <Reveal
              key={r.name}
              delay={i * 0.08}
              className="flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-8"
              data-testid={`review-${i}`}
            >
              <Stars rating={r.rating} size={14} />
              <p className="mt-5 flex-1 font-serif text-xl font-light italic leading-relaxed text-ivory/90">
                “{r.text}”
              </p>
              <div className="mt-6">
                <p className="text-sm text-ivory">{r.name}</p>
                <p className="mt-0.5 text-[0.62rem] uppercase tracking-[0.22em] text-champagne/70">
                  {r.location}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
